<!--
 Result Container Mobile
 Component show Suggestions and Results in row style for mobile devices only.
 devs@droxit.de
 Copyright (c) 2021 droxIT GmbH
-->

<template>
  <b-container fluid="md">
    <b-row>
      <b-col class="rocketsearch-column-header">
        <b-row>
          <TagsContainerMobile :filters="filters" :key="getTagsKey()" />
        </b-row>
        <b-row class="rocketsearch-action-buttons-row" align-h="center">
          <b-button variant="primary" class="rocketsearch-action-buttons rocketsearch-filter-button" @click="toggleFilterView">
            <b-icon icon="filter" class="rocketsearch-filter-icon" style="vertical-align: middle;"></b-icon>
            {{$t('filter_button')}}
          </b-button>
          <b-col cols=12 style="padding: 0px;">
            <hr class="rocketsearch-column-header-underline">
          </b-col>
        </b-row>
      </b-col>
      <b-col v-if="!showFilters" md="8" id="rocketsearch-result-column">
        <b-row v-if=hits align-h="between" align-v="center">
          <b-col cols=6>
            <b-pagination id="rocketsearch-result-pagination"
              v-model="currPage"
              :total-rows="hits"
              :per-page="searchSize"
              @input ="$root.$emit('TurnPage', currPage)"
              align="left"
              size="sm"
            ></b-pagination>
          </b-col>
          <b-col cols=6 class="rocketsearch-result-frame">
            {{ resultsFrame }}
          </b-col>
        </b-row>
        <ResultList :results=results :showAllResults="false" />
      </b-col>
      <b-col v-else md="8" id="rocketsearch-facet-column">
        <FacetsContainerMobile :facets=results.facets :filters=filters />
        <b-row align-h="center">
          <b-button v-if="hits" variant="primary" class="rocketsearch-action-buttons rocketsearch-results-button" @click="toggleFilterView">
            {{$t('button_number_results', [hits])}}
          </b-button>
          <b-button v-else variant="primary" class="rocketsearch-action-buttons rocketsearch-results-button" @click="toggleFilterView">
            {{$t('button_no_results')}}
          </b-button>
        </b-row>
      </b-col>
    </b-row>
    <b-row align-h="center" class="rocketsearch-close-row">
      <b-col cols=12>
        <hr class="rocketsearch-column-header-underline">
      </b-col>
      <b-col cols=12>
        <b-button variant="primary" class="rounded-circle px-2 rocketsearch-close-button" @click="close">
          <b-icon icon="x" scale="2" style="vertical-align: middle;"></b-icon>
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
   import ResultList from './ResultList.vue'
   import FacetsContainerMobile from './ShopComponents/FacetsContainerMobile.vue'
   import TagsContainerMobile from './ShopComponents/TagsContainerMobile.vue'

export default {
  name: "ResultsMobile",
  props: {
    suggests: Array,
    searchTerm: String,
    currentPage: Number,
    results: Object,
    hits: Number,
    filters: Object
  },
  watch: {
    suggests: function(newVal) {
      if (newVal) {
        this.$root.$emit('RocketSuggestUpdatedEvent', newVal);
      } else {
        this.$root.$emit('RocketSuggestUpdatedEvent', []);
      }
    }
  },
  components: {
    ResultList,
    FacetsContainerMobile,
    TagsContainerMobile
  },
  data: function () {
    return {
      searchSize: window.__env.config.NUM_RESULTS_MOBILE,
      currPage: this.currentPage,
      showFilters: false,
    }
  },
  computed: {
    resultsFrame: function () {
      let from = 1+(this.searchSize*(this.currPage-1));
      let to = Math.min(this.searchSize*this.currPage, this.hits);
      return this.$t('results_frame', [from, to, this.hits]);
    }
  },
  methods: {
    /*
      * Show / Hide Facets Container on click on filter button.
    */
    toggleFilterView(){
      this.showFilters = !this.showFilters;
    },
    close(){
      this.$root.$emit('ClickOutsideEvent');
    },
    getTagsKey(){
      // compute key as sum of numbers of all set filter values
      var key = Object.values(this.filters).map(x => x.length).reduce(function(a, x){ return a+x }, 0);
      return key;
    }
  }
}
</script>

<style scoped>
</style>